<span [ngSwitch]="element.tagName">
    <h1
        *ngSwitchCase="'H1'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
        <kd-document-lock *ngIf="!index"></kd-document-lock>
    </h1>

    <h2
        *ngSwitchCase="'H2'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
    </h2>

    <h3
        *ngSwitchCase="'H3'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
    </h3>

    <h4
        *ngSwitchCase="'H4'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
    </h4>

    <h5
        *ngSwitchCase="'H5'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
    </h5>

    <h6
        *ngSwitchCase="'H6'"
        class="kd-document-anchor-container"
        [attr.data-anchor]="element.id"
        [attr.data-text]="element.innerText"
    >
        <span [innerHTML]="element.innerHTML"></span>
        <a class="anchor" [id]="element.id"></a>

        <kd-document-anchor [id]="element.id"></kd-document-anchor>
    </h6>
</span>
